import { groupBy } from 'lodash';
import { SubMenu } from '.';
import { THEME_MODE } from 'src/interfaces/theme';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

interface Props {
  data: SubMenu[];
}

const MenuDropdown = ({ data }: Props) => {
  const userTheme = useSelector((state: any) => state.theme);
  const { push } = useHistory();
  const isDarkMode = userTheme === THEME_MODE.DARK;

  return (
    <div className={`dropdown-popup ${isDarkMode ? 'dark-theme' : 'light-theme'}`}>
      {data.map((item, index) => {
        return (
          <div key={index} className="flex gap-[16px] items-center">
            {item.icon && <img className="w-[20px] h-[20px]" src={item.icon} />}
            <div
              className={`${isDarkMode ? 'text-white hover:text-blue-400' : 'text-black hover:text-blue-600'} cursor-pointer`}
              onClick={() => {
                item.path ? push(item.path) : window.open(item.link, '__blank');
              }}
            >
              <span className="font-medium">{item.label}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MenuDropdown;
